<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/enterprise/add_service')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <!-- <el-select filterable 
      style="float: right"
      v-model="screen.type"
      placeholder="请选择时间类型"
    >
      <el-option
        :label="item.title"
        :value="item.id"
        v-for="(item, index) in typeList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-input
      style="float: right; margin-right: 10px; width: 200px"
      v-model="screen.company_name"
      placeholder="请输入公司名称"
    ></el-input>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.type_id"
      placeholder="请选择所属类型"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.title"
        :value="item.id"
        v-for="(item, index) in ScreenTypeList"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择所属园区"
      :disabled="userInfo.park_id != 0"
      @change="parkChange"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="公司名称" align="center" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.company_name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属园区" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.park ? scope.row.park.name : "" }}
        </template>
      </el-table-column>
      <el-table-column label="公司logo" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.logo"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageOss + scope.row.logo"
          />
        </template>
      </el-table-column>
      <el-table-column label="是否免费" align="center">
        <template slot-scope="scope">
          {{ scope.row.is_free == 1 ? "是" : "否" }}
        </template>
      </el-table-column>

      <el-table-column label="公司联系方式" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.tel }}
        </template>
      </el-table-column>
      <el-table-column label="公司地址" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.address }}</div>
        </template>
      </el-table-column>
      <el-table-column label="添加时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="230"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/enterprise/service_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/enterprise/edit_service')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/enterprise/del_service')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            @change="formParkChanged"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" prop="company_name">
          <el-input
            v-model="ruleForm.company_name"
            :disabled="cztype == 'see'"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务类型" prop="type_id">
          <el-select
            filterable
            v-model="ruleForm.type_id"
            placeholder="请选择服务类型"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in typeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收费类型" prop="is_free">
          <el-radio-group
            v-model="ruleForm.is_free"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">免费</el-radio>
            <el-radio :label="0">不免费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="折扣" prop="pent" v-if="ruleForm.is_free == 0">
          <el-input
            type="number"
            class="w4 numInput"
            v-model="ruleForm.pent"
            :disabled="cztype == 'see'"
            min="1"
            max="10"
            placeholder="请输入折扣"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="describle">
          <el-input
            v-model="ruleForm.describle"
            :disabled="cztype == 'see'"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司logo" prop="logo">
          <!-- class="avatar-uploader" -->
          <!-- <el-upload
            :disabled="cztype == 'see'"
              name="file[]"
              list-type="picture-card"
              :data="{type:'image'}"
              :file-list="fileList"
              :action="ossUpload"
              :headers="{ token: token }"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
            >
              <img
                v-if="ruleForm.logo"
                :src="imageOss + ruleForm.logo"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>已修改 -->

          <el-upload
          :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="轮播图" prop="thumb">
          <el-upload
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="thumbFileList"
            :on-remove="handleRemovePic"
            :on-success="thumbHandleAvatarSuccess"
            :disabled="cztype == 'see'"
          >
            <!-- <img
              v-if="ruleForm.thumb"
              :src="imageUrl + ruleForm.thumb"
              class="avatar-uploaders"
            /> -->
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="公司联系电话" prop="tel">
          <el-input
            maxlength="11"
            v-model="ruleForm.tel"
            :disabled="cztype == 'see'"
            placeholder="请输入公司联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input
            v-model="ruleForm.address"
            :disabled="cztype == 'see'"
            placeholder="请输入公司地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="ruleForm.sort"
            :disabled="cztype == 'see'"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司介绍详情" prop="content">
          <Editor
            :disabled="cztype == 'see'"
            style="width: 100%"
            v-model="ruleForm.content"
          />
          <!-- <el-input  v-model="ruleForm.about" :disabled="cztype == 'see'" placeholder="请输入公司简介"></el-input> -->
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import { mapGetters } from "vuex";
import { openPark, delImage } from "@/api/index";
import {
  qfServiceList,
  qfServiceAdd,
  qfServiceEdit,
  qfServiceInfo,
  qfServiceDel,
  qfTypeList,
  get_enter_types,
} from "@/api/enterpriseFw";
import { getToken } from "@/utils/auth";
import { number } from "echarts";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加企业",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        company_name: "",
        park_id: "",
        type_id: "",
      },
      ruleForm: {},
      thumbFileList: [],
      rules: {
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        park_id: [
          { required: true, message: "请选择菜单类型", trigger: "change" },
        ],
        type_id: [
          { required: true, message: "请选择服务类型", trigger: "change" },
        ],
        logo: [
          { required: true, message: "请选择公司logo", trigger: "change" },
        ],
        thumb: [{ required: true, message: "请选择轮播图", trigger: "change" }],
        is_free: [
          { required: true, message: "请选择收费类型", trigger: "change" },
        ],
        pent: [{ required: true, message: "请输入折扣", trigger: "blur" }],
        describle: [{ required: true, message: "请输入描述", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入公司联系电话", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        content: [
          { required: true, message: "请输入公司介绍", trigger: "blur" },
        ],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      parkList: [],
      typeList: [],
      ScreenTypeList: [],
      clearThumb: [],
      fileList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }

    this.getPark();
    this.getScreenType();
    this.fetchData();
  },
  methods: {
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.logo = "";
    },
    thumbHandleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.thumb = list.join(",");
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearThumb.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.thumb = list.join(",");
    },
    parkChange(e) {
      this.getScreenType(e);
    },
    formParkChanged(e) {
      this.getType(e);
      this.ruleForm.type_id = "";
    },

    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        type_id: "",
        company_name: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
      this.getScreenType();
    },
    // 获取类型
    getScreenType(id) {
      get_enter_types({ park_id: id }).then((response) => {
        this.ScreenTypeList = response.data.data;
      });
    },
    // 获取类型
    getType(id) {
      get_enter_types({ park_id: id }).then((response) => {
        this.typeList = response.data.data;
      });
    },
    // 添加企业用户
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (this.ruleForm.logo) {
          this.delImg(this.ruleForm.logo);
        }
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.logo = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              qfServiceEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.thumbFileList = [];
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      this.getInfo(val.id);
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.thumbFileList = [];
      // this.ruleForm = val
      this.getInfo(val.id);
      this.drawer = true;
    },
    getInfo(id) {
      qfServiceInfo({ id: id }).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          park_id: Number(res.data.info.park_id),
          type_id: res.data.info.type_id,
          sort: res.data.info.sort,
          company_name: res.data.info.company_name,
          logo: res.data.info.logo,
          describle: res.data.info.describle,
          is_free: res.data.info.is_free,
          address: res.data.info.address,
          tel: res.data.info.tel,
          content: res.data.info.content,
          pent: res.data.info.pent,
          thumb: res.data.info.thumb,
        };
        this.getType(this.ruleForm.park_id);
        // this.oldImg = res.data.logo;
        this.fileList = [];
        if (res.data.info.logo) {
          this.fileList.push({ url: this.imageOss + res.data.info.logo });
        }
        var lists = res.data.info.thumb.split(",");
        this.thumbFileList = lists.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
    },
    handleDelete(id) {
      const data = {
        id: id,
      };
      this.$confirm("确认删除？")
        .then(() => {
          qfServiceDel(data).then((res) => {
            // this.openUserRole(val.id);
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            this.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              qfServiceAdd(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加公司";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        type_id: "",
        sort: "",
        company_name: "",
        logo: "",
        describle: "",
        is_free: 1,
        address: "",
        tel: "",
        content: "",
        thumb: "",
        pent: "",
      };
      this.fileList = [];
      this.thumbFileList = [];

      this.drawer = true;
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
        this.getType(this.ruleForm.park_id);
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      qfServiceList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    margin-bottom: 10px;
  }
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.qyUser {
  ::v-deep .el-drawer__body {
    padding: 0 20px;
  }
}
.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin: 0 5px 5px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.w4 {
  width: 400px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
